import { gql, useQuery } from "@apollo/client";

export function useUserQuestionnaires() {
  return useQuery(gql`
    query getUserQuestionnaires {
      user_questionnaires {
        _id
        name
        type
        start_date
        end_date
        year
        questions {
            _id
            question
            answer_id
        }
      }
    }
  `);
}

export function useUserQuestionnairesForOnboarding() {
  return useQuery(gql`
    query getUserQuestionnairesForOnboarding {
      user_questionnaire_onboarding {
        _id
        name
        questions {
            _id
            question
            answer_id
            answer_details {
              _id
              answers {
                _id
                label
              }
            }
        }
      }
    }
  `);
}
export function useUserQuestionnairesScheduled() {
  return useQuery(gql`
    query getUserQuestionnairesScheduled {
      user_questionnaire_scheduled {
        _id
        name
        questions {
            _id
            question
            answer_id
            answer_details {
              _id
              answers {
                _id
                label
              }
            }
        }
      }
    }
  `);
}

export function useUserQuestionnaireDetails(id : string) {
  return useQuery(gql`
    query getUserQuestionnairesDetail($_id : MongoID!) {
      user_questionnaire(_id : $_id) {
        _id
        name
        questions {
          _id
          question
          answer_id
        }
      }
    }
  `,{
    variables : {
      _id : id
    }
  });
}